/*
 * Variant product (sections/variant-product.liquid)
 *
 * For simple products that use REAL Shopify variants. Renders an option picker only for the options
 * that actually exist (a lone "Default Title" variant renders none), keeps price / availability /
 * hero photo / spec chips in sync with the chosen variant, and adds to the normal Shopify cart.
 *
 * DOM for each option group is built once and afterwards only updated in place (active state,
 * upcharge tags) — re-creating image cards on every selection makes them flash on phones.
 */
(function () {
  'use strict';

  var dataEl = document.getElementById('lbv-data');
  var root = document.querySelector('.lbv');
  if (!dataEl || !root) return;

  var D;
  try {
    D = JSON.parse(dataEl.textContent);
  } catch (e) {
    console.error('[lbv] could not parse product data', e);
    return;
  }

  var variants = D.variants || [];
  // spec/color metafields can come through as objects for some metafield types; only plain text or numbers are usable
  variants.forEach(function (v) {
    ['weight', 'ext', 'int', 'gun', 'hex', 'w', 'h', 'd'].forEach(function (k) {
      if (v[k] != null && typeof v[k] !== 'string' && typeof v[k] !== 'number') v[k] = null;
    });
  });
  var media = D.media || [];
  var $ = function (id) { return document.getElementById(id); };

  function money(cents) {
    return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function shortMoney(cents) {
    return money(cents).replace('.00', '');
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // ---------- options that are worth showing ----------
  var optDefs = [];
  var cardMode = root.getAttribute('data-card-images') === 'true';
  (D.options || []).forEach(function (o, i) {
    var seen = {};
    var values = [];
    variants.forEach(function (v) {
      var val = v.options[i];
      if (val != null && !seen[val]) { seen[val] = true; values.push(val); }
    });
    var onlyDefault = values.length === 1 && /^default title$/i.test(values[0]);
    // a lone Color value (card-image products) still shows as a swatch, like the other brands' color step
    var loneColor = cardMode && values.length === 1 && /colou?r/i.test(o.name);
    if (onlyDefault || o.name === 'Title' || (values.length < 2 && !loneColor)) return; // nothing to choose
    // "Select Your Size:" / "Choose Your Size:" -> "Size"; anything else is used as-is
    var nice = String(o.name).replace(/^(select|choose)\s+(your\s+)?/i, '').replace(/:\s*$/, '');
    optDefs.push({ name: o.name, label: nice.charAt(0).toUpperCase() + nice.slice(1), index: i, values: values });
  });

  // ---------- variant selection ----------
  var current = variants.filter(function (v) { return v.id === D.current; })[0] || variants[0];
  var sel = current ? current.options.slice() : [];

  function findExact(values) {
    for (var i = 0; i < variants.length; i++) {
      var ok = true;
      for (var k = 0; k < values.length; k++) if (variants[i].options[k] !== values[k]) { ok = false; break; }
      if (ok) return variants[i];
    }
    return null;
  }
  // choosing a value that no variant combines with the other current picks: keep the new value and
  // change the other picks as little as possible
  function selectValue(optIndex, value) {
    var next = sel.slice();
    next[optIndex] = value;
    var exact = findExact(next);
    if (exact) { current = exact; sel = exact.options.slice(); return; }
    var best = null, bestScore = -1;
    variants.forEach(function (v) {
      if (v.options[optIndex] !== value) return;
      var score = 0;
      for (var k = 0; k < sel.length; k++) if (k !== optIndex && v.options[k] === sel[k]) score++;
      if (score > bestScore) { bestScore = score; best = v; }
    });
    if (best) { current = best; sel = best.options.slice(); }
  }

  // ---------- option groups (built once) ----------
  function isColorOption(def) {
    return /colou?r|finish|paint/i.test(def.name);
  }
  function firstVariantWith(index, value, key) {
    for (var i = 0; i < variants.length; i++) if (variants[i].options[index] === value && variants[i][key]) return variants[i];
    return null;
  }
  var CARD_IMAGES = root.getAttribute('data-card-images') === 'true';
  // tooltip body for a kit option written like "TITLE: PART | PART | PART" -> one line per part
  function tipParts(val) {
    var i = val.indexOf(':');
    return i < 0 ? [] : val.slice(i + 1).split('|').map(function (s) { return s.replace(/^\s+|\s+$/g, ''); }).filter(Boolean);
  }
  function tipText(val) { return tipParts(val).length > 0; }
  var tipEl = null, tipFor = null, tipPinned = false;
  function hideTip() {
    if (!tipEl) tipEl = $('lbv-tooltip');
    if (tipEl) tipEl.hidden = true;
    tipFor = null; tipPinned = false;
  }
  function showTip(icon) {
    if (!tipEl) tipEl = $('lbv-tooltip');
    var val = icon.getAttribute('data-tipval');
    var parts = tipParts(val);
    if (!tipEl || !parts.length) return;
    tipFor = icon;
    tipEl.innerHTML = '<span>' + esc(val.slice(0, val.indexOf(':'))) + ': ' + parts.map(esc).join(' | ') + '</span>';
    tipEl.hidden = false;
    var r = icon.getBoundingClientRect(), w = tipEl.offsetWidth, h = tipEl.offsetHeight;
    var left = Math.min(Math.max(8, r.left + r.width / 2 - w / 2), window.innerWidth - w - 8);
    var top = r.top - h - 10;
    if (top < 8) top = r.bottom + 10;
    tipEl.style.left = left + 'px';
    tipEl.style.top = top + 'px';
  }
  root.addEventListener('mouseover', function (e) { var i = e.target.closest('.lbc-tip'); if (i && !tipPinned) showTip(i); });
  root.addEventListener('mouseout', function (e) { if (e.target.closest('.lbc-tip') && !tipPinned) hideTip(); });
  root.addEventListener('keydown', function (e) {
    var i = e.target.closest && e.target.closest('.lbc-tip');
    if (i && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); if (tipFor === i && tipPinned) hideTip(); else { showTip(i); tipPinned = true; } }
    if (e.key === 'Escape') hideTip();
  });
  document.addEventListener('click', function (e) { if (!e.target.closest || !e.target.closest('.lbc-tip')) hideTip(); });
  window.addEventListener('scroll', hideTip, { passive: true });
  function buildOptions() {
    var host = $('lbv-options');
    host.innerHTML = optDefs.map(function (def, di) {
      var swatches = isColorOption(def) && def.values.every(function (v) { return !!firstVariantWith(def.index, v, 'hex'); });
      var cards = def.values.map(function (val) {
        var withImg = firstVariantWith(def.index, val, 'img');
        var kitV = null, flat = false;
        if (CARD_IMAGES) {
          // opt-in per product (tag card-option-images): size / lock cards use the variant's own size_images / lock_image
          // metafields, and an upgrade card shows its kit photo, or no photo at all for "No ..." (Home Series)
          var nm = def.name, hit = null;
          if (/size/i.test(nm)) { hit = firstVariantWith(def.index, val, 'sizeimg'); if (hit) { withImg = { img: hit.sizeimg }; flat = true; } }
          else if (/lock/i.test(nm)) { hit = firstVariantWith(def.index, val, 'lockimg'); if (hit) withImg = { img: hit.lockimg }; }
          else if (/upgrade|kit|bundle/i.test(nm)) {
            if (/^no\b/i.test(val)) withImg = null;
            else { kitV = firstVariantWith(def.index, val, 'kit'); if (kitV) { withImg = { img: kitV.kit }; flat = true; } }
          }
        }
        var isKit = !!kitV;
        if (swatches) {
          var hex = firstVariantWith(def.index, val, 'hex').hex;
          return '<button type="button" class="lbc-swatch" data-opt="' + di + '" data-val="' + esc(val) + '" title="' + esc(val) + '" aria-label="' + esc(val) + '" style="background-color:' + esc(hex) + ';"></button>';
        }
        return '<button type="button" class="lbc-card' + (withImg ? '' : ' lbc-card--text') + (isKit ? ' lbc-card--kit' : '') + '" data-opt="' + di + '" data-val="' + esc(val) + '">' +
          (withImg ? '<img class="lbc-card-img' + (flat ? ' lbc-card-img--flat' : '') + '" src="' + esc(withImg.img) + '" alt="" loading="lazy" width="72" height="72">' : '') +
          '<span class="lbc-card-label">' + esc(isKit && tipText(val) ? val.slice(0, val.indexOf(':')) : val) + '</span><span class="lbc-card-price"></span>' +
          (isKit && tipText(val) ? '<span class="lbc-tip" role="button" tabindex="0" data-tipval="' + esc(val) + '" aria-label="About ' + esc(val) + '">i</span>' : '') + '</button>';
      }).join('');
      return '<div class="lbv-group ' + (swatches ? 'color-picker' : 'lock-picker') + '" data-group="' + di + '">' +
        '<h3 class="section-title">Select Your ' + esc(def.label) + ':</h3>' +
        '<div class="' + (swatches ? 'lbc-swatches' : 'lbc-cards lbc-cards--sm') + '">' + cards + '</div>' +
        '<div class="selection-display"><span class="selection-label">Selected ' + esc(def.label) + ':</span><span class="selection-value" data-label="' + di + '"></span></div>' +
        '</div>';
    }).join('');
  }

  function syncOptions() {
    optDefs.forEach(function (def, di) {
      var group = root.querySelector('[data-group="' + di + '"]');
      if (!group) return;
      var nodes = group.querySelectorAll('[data-opt]');
      for (var i = 0; i < nodes.length; i++) {
        var b = nodes[i];
        var val = b.getAttribute('data-val');
        var on = val === sel[def.index];
        if (b.classList.contains('active') !== on) b.classList.toggle('active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        // what this choice would do to the price / availability, holding the other picks
        var probe = sel.slice();
        probe[def.index] = val;
        var cand = findExact(probe);
        b.classList.toggle('is-unavailable', !!cand && !cand.available);
        var tag = b.querySelector('.lbc-card-price');
        if (tag) {
          // The upcharge on a card is fixed: this option vs the FIRST option in its group (the baseline), holding the other
          // picks. It does not change as the shopper picks other options in the same group, and size cards show none.
          var txt = '';
          if (!/size/i.test(def.name) && cand) {
            var baseProbe = sel.slice();
            baseProbe[def.index] = def.values[0];
            var baseVar = findExact(baseProbe);
            var delta = baseVar ? cand.price - baseVar.price : 0;
            if (delta > 0) txt = '+' + shortMoney(delta);
          }
          if (tag.textContent !== txt) tag.textContent = txt;
        }
      }
      var label = group.querySelector('[data-label="' + di + '"]');
      if (label) {
        var cur = sel[def.index] || '';
        // kit options ("TITLE: PART | PART") show just the title here; the card's (i) tooltip lists the parts
        if (CARD_IMAGES && /upgrade|kit|bundle/i.test(def.name) && tipText(cur)) cur = cur.slice(0, cur.indexOf(':'));
        label.textContent = cur;
      }
    });
  }

  // ---------- price ----------
  function renderPrice() {
    var el = $('lbv-price');
    var html;
    if (current.compare && current.compare > current.price) {
      var pct = Math.round((current.compare - current.price) * 100 / current.compare);
      html = '<div class="price-compare-container"><span class="compare-price">' + money(current.compare) + '</span><span class="percent-badge">' + pct + '% Off</span></div>' +
        '<span class="sale-price">' + money(current.price) + '</span>';
    } else {
      html = money(current.price);
    }
    if (el.getAttribute('data-html') !== html) { el.innerHTML = html; el.setAttribute('data-html', html); }
    $('lbv-total').textContent = money(current.price * qty());
  }

  // ---------- specs ----------
  var specsKey = null;
  function renderSpecs() {
    var v = current;
    var key = v.id;
    if (specsKey === key) return;
    specsKey = key;
    var rows = [];
    var gun = parseFloat(v.gun) > 0 ? v.gun : (parseFloat(D.fallbackGun) > 0 ? D.fallbackGun : null);
    if (gun) rows.push(['target', 'Up to ' + esc(gun) + ' long guns']);
    if (v.weight) rows.push(['weight', esc(v.weight) + ' lbs']);
    // dimensions: a ready-made string when the product has one, else built from its height / width / depth
    var dims = v.ext;
    if (!dims) {
      var parts = [];
      if (v.h) parts.push(v.h + '" H');
      if (v.w) parts.push(v.w + '" W');
      if (v.d) parts.push(v.d + '" D');
      if (parts.length >= 2) dims = parts.join(' x ');
    }
    if (dims) rows.push(['maximize', 'External: ' + esc(dims)]);
    if (v.int) rows.push(['minimize', 'Internal: ' + esc(v.int)]);
    rows.push(['shield-check', 'Limited Life-Time Warranty']);
    $('lbv-specs').innerHTML = rows.map(function (r) {
      return '<div class="info-item"><i data-lucide="' + r[0] + '" class="info-icon"></i><span class="info-text">' + r[1] + '</span></div>';
    }).join('');
    if (window.lucide && window.lucide.createIcons) window.lucide.createIcons();
  }

  // ---------- gallery ----------
  var heroSrc = null;
  function mediaById(id) {
    for (var i = 0; i < media.length; i++) if (String(media[i].id) === String(id)) return media[i];
    return null;
  }
  function setHero(src) {
    var img = $('lbv-hero-img');
    if (!src || heroSrc === src) return;
    heroSrc = src;
    img.setAttribute('src', src);
    document.querySelectorAll('#lbv-thumbs .lbc-thumb').forEach(function (t) {
      t.classList.toggle('active', t.getAttribute('data-src') === src);
    });
  }
  function buildThumbs() {
    var strip = $('lbv-thumbs');
    if (media.length < 2) { strip.hidden = true; return; }
    strip.innerHTML = media.map(function (m, i) {
      return '<button type="button" class="lbc-thumb" data-src="' + esc(m.src) + '" aria-label="Product photo ' + (i + 1) + '">' +
        '<img src="' + esc(m.thumb) + '" alt="" loading="lazy" width="80" height="80"></button>';
    }).join('');
  }
  function syncHero() {
    var m = current.media ? mediaById(current.media) : null;
    if (m) setHero(m.src);
    else if (!heroSrc && media[0]) setHero(media[0].src);
  }

  // thumbnail strip: scrollbar hidden, so support drag-to-scroll with a mouse (touch/trackpad scroll natively)
  var dragMoved = false;
  (function () {
    var strip = $('lbv-thumbs');
    var down = false, startX = 0, startLeft = 0;
    strip.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      down = true; dragMoved = false; startX = e.clientX; startLeft = strip.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) { dragMoved = true; strip.classList.add('dragging'); }
      strip.scrollLeft = startLeft - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false; strip.classList.remove('dragging');
    });
  })();

  // ---------- quantity + add to cart ----------
  function qty() {
    if (!$('lbv-qty-input')) return 1; // no quantity control on this template: always one safe
    var n = parseInt($('lbv-qty-input').value, 10);
    return isFinite(n) && n > 0 ? Math.min(n, 99) : 1;
  }
  var busy = false;
  function renderButton() {
    var btn = $('lbv-add');
    if (busy) return;
    btn.disabled = !current.available;
    btn.textContent = current.available ? 'Add to Cart' : 'Sold Out';
  }
  function showMessage(text) {
    var m = $('lbv-message');
    m.textContent = text || '';
    m.hidden = !text;
  }
  function addToCart() {
    if (busy || !current.available) return;
    busy = true;
    var btn = $('lbv-add');
    btn.disabled = true;
    btn.textContent = 'Adding…';
    showMessage('');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: current.id, quantity: qty() }] })
    })
      .then(function (r) {
        return r.json().then(function (j) { return { ok: r.ok, body: j }; });
      })
      .then(function (res) {
        if (!res.ok) throw new Error((res.body && (res.body.description || res.body.message)) || 'Could not add to cart.');
        try { document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: res.body } })); } catch (e) {}
        window.location.href = '/cart';
      })
      .catch(function (err) {
        busy = false;
        showMessage(err.message || 'Could not add to cart. Please try again.');
        renderButton();
      });
  }

  // ---------- render + events ----------
  function syncUrl() {
    if (variants.length < 2 || !window.history || !history.replaceState) return;
    try {
      var u = new URL(window.location.href);
      u.searchParams.set('variant', current.id);
      history.replaceState(null, '', u.toString());
    } catch (e) {}
  }
  function renderAll(fromUser) {
    syncOptions();
    renderPrice();
    renderSpecs();
    renderButton();
    syncHero();
    if (fromUser) syncUrl();
  }

  root.addEventListener('click', function (e) {
    var tipBtn = e.target.closest('.lbc-tip');
    if (tipBtn && root.contains(tipBtn)) { // the (i) icon explains a card, it does not select it
      e.preventDefault(); e.stopPropagation();
      if (tipFor === tipBtn && tipPinned) hideTip(); else { showTip(tipBtn); tipPinned = true; }
      return;
    }
    var opt = e.target.closest('[data-opt]');
    if (opt && root.contains(opt)) {
      selectValue(optDefs[+opt.getAttribute('data-opt')].index, opt.getAttribute('data-val'));
      renderAll(true);
      return;
    }
    var thumb = e.target.closest('.lbc-thumb');
    if (thumb && root.contains(thumb)) {
      if (dragMoved) { dragMoved = false; return; }
      setHero(thumb.getAttribute('data-src'));
      return;
    }
    var stepBtn = e.target.closest('[data-qty]');
    if (stepBtn) {
      var input = $('lbv-qty-input');
      input.value = Math.min(99, Math.max(1, qty() + parseInt(stepBtn.getAttribute('data-qty'), 10)));
      renderPrice();
    }
  });
  if ($('lbv-qty-input')) {
    $('lbv-qty-input').addEventListener('input', renderPrice);
    $('lbv-qty-input').addEventListener('change', function () { this.value = qty(); renderPrice(); });
  }
  $('lbv-add').addEventListener('click', addToCart);
  window.addEventListener('pageshow', function (e) { if (e.persisted) { busy = false; renderButton(); } });

  // ---------- init ----------
  if (!current) { console.warn('[lbv] product has no variants'); return; }
  buildOptions();
  buildThumbs();
  renderAll(false);
  if (window.lucide && window.lucide.createIcons) window.lucide.createIcons();
})();
